/**
 * @generated SignedSource<<0c4709713290adc507fb984de4b8061f>>
 * @relayHash 611b5c137082bdd88dafebf77d7cf28d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d091a7e8628bf2733c9afa6ec2e53fd5331f33bda7e8a0aae6dbb29dd3621063

import type { ConcreteRequest } from 'relay-runtime';
export type TeamTqlExplainerAggQuery$variables = {
  includeTeams: boolean;
  searchString: string;
};
export type TeamTqlExplainerAggQuery$data = {
  readonly team?: {
    readonly explainTeamsTql: {
      readonly explanation: string;
    } | null;
  } | null;
};
export type TeamTqlExplainerAggQuery = {
  response: TeamTqlExplainerAggQuery$data;
  variables: TeamTqlExplainerAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeTeams"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v2 = [
  {
    "condition": "includeTeams",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "searchString",
                "variableName": "searchString"
              }
            ],
            "concreteType": "TeamsTQLExplanation",
            "kind": "LinkedField",
            "name": "explainTeamsTql",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "explanation"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TeamTqlExplainerAggQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamTqlExplainerAggQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "d091a7e8628bf2733c9afa6ec2e53fd5331f33bda7e8a0aae6dbb29dd3621063",
    "metadata": {},
    "name": "TeamTqlExplainerAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a1197ed66f1e5d3b81e7e894e4a9fc84";

export default node;
